__turbopack_context__.v({
  "centered": "PointsLoader-module__OZWfUq__centered",
  "circle": "PointsLoader-module__OZWfUq__circle",
  "container": "PointsLoader-module__OZWfUq__container",
  "dark": "PointsLoader-module__OZWfUq__dark",
  "light": "PointsLoader-module__OZWfUq__light",
  "scaleAnimationEven": "PointsLoader-module__OZWfUq__scaleAnimationEven",
  "scaleAnimationOdd": "PointsLoader-module__OZWfUq__scaleAnimationOdd",
});
